import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import CRFViewer from './CRFViewer';
import './CRFPage.css';

const CRFPage = () => {
  const { templateId } = useParams();
  const [crfModel, setCrfModel] = useState(null);
  const [columnView, setColumnView] = useState(1);
  const [showTemplateName, setShowTemplateName] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Example: Load CRF model (replace with actual data fetching logic)
  const loadCRFModel = async () => {
    // TODO: Implement actual data fetching from your database
    // For now, this is a placeholder structure
    setError('CRF data loading not implemented. Please provide CRF model data.');
  };

  // If you have CRF model data, you can pass it directly
  // For demonstration, you can set it manually or fetch from API
  React.useEffect(() => {
    if (templateId) {
      loadCRFModel();
    }
  }, [templateId]);

  return (
    <div className="crf-page">
      <div className="crf-page-header">
        <h2>Case Report Form (CRF)</h2>
        <div className="crf-controls">
          <label>
            <input
              type="checkbox"
              checked={showTemplateName}
              onChange={(e) => setShowTemplateName(e.target.checked)}
            />
            Show Template Name
          </label>
          <label>
            Column View:
            <select
              value={columnView}
              onChange={(e) => setColumnView(parseInt(e.target.value))}
            >
              <option value={1}>1 Column</option>
              <option value={2}>2 Columns</option>
              <option value={3}>3 Columns</option>
            </select>
          </label>
        </div>
      </div>

      {error && (
        <div className="alert alert-warning">
          <strong>Note:</strong> {error}
          <br />
          <small>To use this component, pass a CRF model object with the structure defined in CRFModel.cs</small>
        </div>
      )}

      {crfModel ? (
        <CRFViewer
          crfModel={crfModel}
          columnView={columnView}
          showTemplateName={showTemplateName}
          templateId={templateId}
        />
      ) : (
        <div className="crf-placeholder">
          <p>No CRF data available. Please provide CRF model data.</p>
          <p className="text-muted">
            The CRF model should match the structure defined in <code>CRFHdrDtlModel</code>.
          </p>
        </div>
      )}
    </div>
  );
};

export default CRFPage;
